var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.detail.logType==2)?_c('HuiAudio',{attrs:{"is-plain-text":true,"name":_vm.detail.fileName},model:{value:(_vm.detail.fileUrl),callback:function ($$v) {_vm.$set(_vm.detail, "fileUrl", $$v)},expression:"detail.fileUrl"}}):_c('p',{domProps:{"innerHTML":_vm._s(_vm.detail.content)}})
}
var staticRenderFns = []

export { render, staticRenderFns }